export default __webpack_public_path__ + "static/media/content.8231fd08.csv";